import React, { useCallback, useState, useLayoutEffect } from "react";
import { useContractKit } from "@celo-tools/use-contractkit";
import { Box, VStack, Text, Heading, Button } from "@chakra-ui/react";
import Layout from "../components/layout";
import NFTCard from "../components/nft-card";
import { currentTokenIds, tokenURI, ownerOfTokenId } from "../lib/NFT";
import { getMetadata } from "../lib/utils";
import {
  claimReward,
  rewardsOfAddress,
  scoreOfAddress,
  updateRewards,
} from "../lib/Score";

function Profile() {
  const [tokens, setTokens] = useState([]);
  const [score, setScore] = useState(null);
  const [rewards, setRewards] = useState(null);
  const { address, kit, performActions } = useContractKit();

  const loadAllTokens = useCallback(async () => {
    let nfts = [];
    const current = await currentTokenIds(kit);
    console.log(current);
    for (let i = 1; i < parseInt(current) + 1; i++) {
      const metadata = await getMetadata(await tokenURI(i, kit));
      const owner = await ownerOfTokenId(i, kit);
      nfts.push({ ...metadata, id: i, owner: owner });
    }
    return nfts.filter((token) => token.owner === address);
  }, [kit, kit.web3]);

  useLayoutEffect(() => {
    if (!kit.web3) return;

    loadAllTokens().then((nfts) => setTokens(nfts));
    scoreOfAddress(kit, address).then((score) => {
      if (!score) return;
      setScore(score);
    });
    rewardsOfAddress(kit, address).then((reward) => {
      if (!reward) return;
      setRewards(kit.web3.utils.fromWei(reward, "ether"));
    });
  }, [kit, kit.web3]);
  return (
    <Layout>
      <Box>
        <Box mb={12}>
          {score && <Text fontSize="lg">Your Score: {score}</Text>}

          {rewards && (
            <Box mt={3}>
              <Text fontSize="lg">
                Your Unclaimed Reward:{" "}
                {parseFloat(rewards.toString()).toFixed(4)} CELO
              </Text>
              <Button
                mt={2}
                size="sm"
                colorScheme="green"
                onClick={() => {
                  claimReward(performActions, address).then(() => {
                    scoreOfAddress(kit, address).then((score) => {
                      if (!score) return;
                      setScore(score);
                    });
                    rewardsOfAddress(kit, address).then((reward) => {
                      if (!reward) return;
                      setRewards(kit.web3.utils.fromWei(reward, "ether"));
                    });
                  });
                }}
              >
                Claim Reward
              </Button>
            </Box>
          )}
        </Box>
        {tokens.length === 0 ? (
          <Heading> Loading</Heading>
        ) : (
          <Box>
            <VStack alignItems="center" spacing="8" mt={12}>
              <Heading>Your NFTs</Heading>
              {tokens.map((t) => (
                <NFTCard token={t} key={t.image} />
              ))}
            </VStack>
          </Box>
        )}
      </Box>
    </Layout>
  );
}

export default Profile;
